var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "920px",
        "append-to-body": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "110px",
            size: "small"
          }
        },
        [
          _vm.isPositionScope
            ? _c(
                "el-form-item",
                { attrs: { label: "岗位", prop: "stationName" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择岗位" },
                      model: {
                        value: _vm.form.stationName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "stationName", $$v)
                        },
                        expression: "form.stationName"
                      }
                    },
                    _vm._l(_vm.configurableStations, function(s) {
                      return _c("el-option", {
                        key: s.value,
                        attrs: { label: s.label, value: s.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isSpecialScope
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "配置对象", prop: "targetType" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.onSpecialTargetTypeChange },
                        model: {
                          value: _vm.form.targetType,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "targetType", $$v)
                          },
                          expression: "form.targetType"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: "person" } }, [
                          _vm._v("单个人员")
                        ]),
                        _c("el-radio", { attrs: { label: "group" } }, [
                          _vm._v("人员组")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.form.targetType === "person"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "人员", prop: "targetId" } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            filterable: "",
                            "select-type": _vm.selectTypeNames.basic_data_User,
                            "default-value": _vm.personUserId,
                            "callback-params": { key: "userId" }
                          },
                          on: { parentCallBack: _vm.onUserSelected }
                        })
                      ],
                      1
                    )
                  : _c(
                      "el-form-item",
                      { attrs: { label: "人员组", prop: "targetId" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              placeholder: "请选择人员组"
                            },
                            model: {
                              value: _vm.form.targetId,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "targetId", $$v)
                              },
                              expression: "form.targetId"
                            }
                          },
                          _vm._l(_vm.groupOptions, function(g) {
                            return _c("el-option", {
                              key: g.uuid,
                              attrs: { label: g.groupName, value: g.uuid }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                _vm.form.targetType === "person"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "叠加模式" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.overlapMode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "overlapMode", $$v)
                              },
                              expression: "form.overlapMode"
                            }
                          },
                          _vm._l(_vm.overlapModeOptions, function(item) {
                            return _c(
                              "el-radio",
                              { key: item.value, attrs: { label: item.value } },
                              [_vm._v(_vm._s(item.label))]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "规则名称", prop: "ruleName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "例如：基础提成" },
                model: {
                  value: _vm.form.ruleName,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "ruleName", $$v)
                  },
                  expression: "form.ruleName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "计算类型", prop: "calcType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  on: { change: _vm.onCalcTypeChange },
                  model: {
                    value: _vm.form.calcType,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "calcType", $$v)
                    },
                    expression: "form.calcType"
                  }
                },
                _vm._l(_vm.calcTypeOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.form.calcType === "percent"
            ? _c(
                "el-form-item",
                { attrs: { label: "提成比例(%)" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: 100,
                      precision: 2,
                      "controls-position": "right"
                    },
                    model: {
                      value: _vm.form.percentRate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "percentRate", $$v)
                      },
                      expression: "form.percentRate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.form.calcType === "fixed"
            ? _c(
                "el-form-item",
                { attrs: { label: "计入方式" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "160px" },
                      model: {
                        value: _vm.form.bizCategoryCombineMode,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "bizCategoryCombineMode", $$v)
                        },
                        expression: "form.bizCategoryCombineMode"
                      }
                    },
                    _vm._l(_vm.bizCategoryCombineModeOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _c("span", { staticClass: "tip-text" }, [
                    _vm._v(
                      "单独计算：该业务类型从总业务计提中剔除后单独算；累加计算：在总业务计提之外额外加上"
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.form.calcType === "fixed"
            ? _c(
                "el-form-item",
                { attrs: { label: "业务分类设置" } },
                [
                  _c("div", { staticClass: "batch-rule-tip" }, [
                    _vm._v(
                      " 每行配置一种业务类型：固定金额按「票数×金额」；提成比例按「计息毛利×比例」。 "
                    )
                  ]),
                  _c(
                    "el-table",
                    {
                      key: "fixed-" + _vm.form.batchFixedConditionField,
                      staticClass: "batch-rule-table biz-category-table",
                      attrs: {
                        data: _vm.form.batchFixedRules,
                        border: "",
                        size: "mini"
                      }
                    },
                    [
                      _c(
                        "el-table-column",
                        {
                          attrs: { width: "240" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm.form.batchFixedConditionField === "lob"
                                      ? _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              multiple: "",
                                              "collapse-tags": "",
                                              filterable: "",
                                              placeholder: "可多选业务类型",
                                              size: "mini"
                                            },
                                            model: {
                                              value: scope.row.conditionValues,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "conditionValues",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.conditionValues"
                                            }
                                          },
                                          _vm._l(_vm.lobOptions, function(l) {
                                            return _c("el-option", {
                                              key: l.value,
                                              attrs: {
                                                label: l.label,
                                                value: l.value
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      : _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              multiple: "",
                                              "collapse-tags": "",
                                              filterable: "",
                                              "allow-create": "",
                                              placeholder: "可多选类型",
                                              size: "mini"
                                            },
                                            model: {
                                              value: scope.row.conditionValues,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "conditionValues",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.conditionValues"
                                            }
                                          },
                                          _vm._l(
                                            _vm.customJobTypeOptions,
                                            function(c) {
                                              return _c("el-option", {
                                                key: c,
                                                attrs: {
                                                  label: c + "类",
                                                  value: c
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3490279851
                          )
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "220px" },
                                  attrs: { size: "mini" },
                                  on: {
                                    change: _vm.onBatchFixedConditionFieldChange
                                  },
                                  model: {
                                    value: _vm.form.batchFixedConditionField,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "batchFixedConditionField",
                                        $$v
                                      )
                                    },
                                    expression: "form.batchFixedConditionField"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "业务类型", value: "lob" }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "自定义业务类型",
                                      value: "customJobType"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c("el-table-column", {
                        attrs: { label: "计算方式", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { size: "mini" },
                                      on: {
                                        change: function($event) {
                                          return _vm.onBatchLineModeChange(
                                            scope.row
                                          )
                                        }
                                      },
                                      model: {
                                        value: scope.row.lineMode,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "lineMode", $$v)
                                        },
                                        expression: "scope.row.lineMode"
                                      }
                                    },
                                    _vm._l(
                                      _vm.bizCategoryLineModeOptions,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2356322795
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "数值", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "value-with-unit" },
                                    [
                                      scope.row.lineMode === "profit"
                                        ? _c("el-input-number", {
                                            staticStyle: { width: "90px" },
                                            attrs: {
                                              min: 0,
                                              max: 100,
                                              precision: 2,
                                              controls: false,
                                              size: "mini"
                                            },
                                            model: {
                                              value: scope.row.rate,
                                              callback: function($$v) {
                                                _vm.$set(scope.row, "rate", $$v)
                                              },
                                              expression: "scope.row.rate"
                                            }
                                          })
                                        : _c("el-input-number", {
                                            staticStyle: { width: "90px" },
                                            attrs: {
                                              min: 0,
                                              precision: 2,
                                              controls: false,
                                              size: "mini"
                                            },
                                            model: {
                                              value: scope.row.fixedAmount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "fixedAmount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.fixedAmount"
                                            }
                                          }),
                                      _c(
                                        "span",
                                        { staticClass: "value-unit" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.lineMode === "profit"
                                                ? "%"
                                                : "元/单"
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2675322114
                        )
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "70" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeBatchFixedRule(
                                            scope.$index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3559355559
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", icon: "el-icon-plus" },
                      on: { click: _vm.addBatchFixedRule }
                    },
                    [_vm._v("添加一档")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.form.calcType === "fixed_bonus"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "计算方式" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "160px" },
                        model: {
                          value: _vm.form.tierMode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "tierMode", $$v)
                          },
                          expression: "form.tierMode"
                        }
                      },
                      _vm._l(_vm.tierModeOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "奖励档位" } },
                  [
                    _c("div", { staticClass: "batch-rule-tip" }, [
                      _vm._v(
                        "多档奖励保存在同一条规则内，按个人总票数或总毛利匹配档位。"
                      )
                    ]),
                    _c(
                      "el-table",
                      {
                        staticClass: "batch-rule-table",
                        attrs: {
                          data: _vm.form.bonusTiers,
                          border: "",
                          size: "mini"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "下限", width: "120" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input-number", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        min: 0,
                                        precision: _vm.bonusTierPrecision,
                                        controls: false,
                                        size: "mini"
                                      },
                                      model: {
                                        value: scope.row.lowerLimit,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "lowerLimit", $$v)
                                        },
                                        expression: "scope.row.lowerLimit"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2385755264
                          )
                        }),
                        _c("el-table-column", {
                          attrs: { label: "上限", width: "120" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input-number", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        min: 0,
                                        precision: _vm.bonusTierPrecision,
                                        controls: false,
                                        size: "mini"
                                      },
                                      model: {
                                        value: scope.row.upperLimit,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "upperLimit", $$v)
                                        },
                                        expression: "scope.row.upperLimit"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1130953121
                          )
                        }),
                        _c("el-table-column", {
                          attrs: { label: "奖励金额(元)", width: "140" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input-number", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        min: 0,
                                        precision: 2,
                                        controls: false,
                                        size: "mini"
                                      },
                                      model: {
                                        value: scope.row.fixedAmount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "fixedAmount",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.fixedAmount"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3765859655
                          )
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "70" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeBonusTier(
                                              scope.$index
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1973452396
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", icon: "el-icon-plus" },
                        on: { click: _vm.addBonusTier }
                      },
                      [_vm._v("添加一档")]
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.form.calcType === "tier"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "阶梯模式" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "160px" },
                        on: { change: _vm.onTierModeChange },
                        model: {
                          value: _vm.form.tierMode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "tierMode", $$v)
                          },
                          expression: "form.tierMode"
                        }
                      },
                      _vm._l(_vm.tierModeOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "160px", "margin-left": "10px" },
                        model: {
                          value: _vm.form.progressiveMode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "progressiveMode", $$v)
                          },
                          expression: "form.progressiveMode"
                        }
                      },
                      _vm._l(_vm.progressiveModeOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "阶梯设置" } },
                  [
                    _c(
                      "el-table",
                      {
                        key: "tier-" + _vm.form.tierMode,
                        attrs: {
                          data: _vm.form.tiers,
                          border: "",
                          size: "mini"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "下限", width: "100" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: _vm.tierPrecision,
                                        controls: false,
                                        size: "mini"
                                      },
                                      model: {
                                        value: scope.row.lowerLimit,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "lowerLimit", $$v)
                                        },
                                        expression: "scope.row.lowerLimit"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4124241118
                          )
                        }),
                        _c("el-table-column", {
                          attrs: { label: "上限", width: "100" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: _vm.tierPrecision,
                                        controls: false,
                                        size: "mini"
                                      },
                                      model: {
                                        value: scope.row.upperLimit,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "upperLimit", $$v)
                                        },
                                        expression: "scope.row.upperLimit"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            78196799
                          )
                        }),
                        _vm.form.tierMode !== "ticket"
                          ? _c("el-table-column", {
                              attrs: { label: "比例(%)", width: "100" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-input-number", {
                                          attrs: {
                                            controls: false,
                                            size: "mini"
                                          },
                                          model: {
                                            value: scope.row.rate,
                                            callback: function($$v) {
                                              _vm.$set(scope.row, "rate", $$v)
                                            },
                                            expression: "scope.row.rate"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1187079318
                              )
                            })
                          : _vm._e(),
                        _vm.form.tierMode === "ticket"
                          ? _c("el-table-column", {
                              attrs: { label: "固定金额(元/票)", width: "120" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-input-number", {
                                          attrs: {
                                            controls: false,
                                            size: "mini"
                                          },
                                          model: {
                                            value: scope.row.fixedAmount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "fixedAmount",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.fixedAmount"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1732395630
                              )
                            })
                          : _vm._e(),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "70" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeTier(scope.$index)
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1280533321
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", icon: "el-icon-plus" },
                        on: { click: _vm.addTier }
                      },
                      [_vm._v("添加阶梯")]
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.form.calcType === "team"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "人员组" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { filterable: "" },
                        model: {
                          value: _vm.form.teamGroupUuid,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "teamGroupUuid", $$v)
                          },
                          expression: "form.teamGroupUuid"
                        }
                      },
                      _vm._l(_vm.groupOptions, function(g) {
                        return _c("el-option", {
                          key: g.uuid,
                          attrs: { label: g.groupName, value: g.uuid }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "扣减基数X(元)" } },
                  [
                    _c("el-input-number", {
                      attrs: {
                        min: 0,
                        precision: 2,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.form.teamDeductBase,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "teamDeductBase", $$v)
                        },
                        expression: "form.teamDeductBase"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "提成比例Y(%)" } },
                  [
                    _c("el-input-number", {
                      attrs: {
                        min: 0,
                        max: 100,
                        precision: 2,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.form.teamPercentRate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "teamPercentRate", $$v)
                        },
                        expression: "form.teamPercentRate"
                      }
                    })
                  ],
                  1
                ),
                _c("el-form-item", { attrs: { label: " " } }, [
                  _c("div", { staticClass: "formula-tip" }, [
                    _c("div", { staticClass: "formula-title" }, [
                      _vm._v("计算公式：")
                    ]),
                    _c("div", { staticClass: "formula-line" }, [
                      _vm._v("计提金额 = (组内"),
                      _c("strong", [_vm._v("他人")]),
                      _vm._v("毛利合计 - 人数 × X) × Y%")
                    ]),
                    _c("div", { staticClass: "formula-note" }, [
                      _vm._v(
                        "「他人」=所选人员组内，除当前计提人员外的所有成员"
                      )
                    ]),
                    _c("div", { staticClass: "formula-note" }, [
                      _vm._v("括号内结果若为负数则计提金额按 0 计算")
                    ]),
                    _c("div", { staticClass: "formula-example" }, [
                      _vm._v("例：组内3人，他人毛利合计 12000，X=2000，Y=10%")
                    ]),
                    _c("div", { staticClass: "formula-example" }, [
                      _vm._v("→ (12000 - 3×2000) × 10% = 6000 × 10% = 600")
                    ])
                  ])
                ])
              ]
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "适用条件" } },
            [
              _vm._l(_vm.form.conditions, function(cond, idx) {
                return _c(
                  "div",
                  { key: idx, staticClass: "condition-row" },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "请选择字段" },
                        on: {
                          change: function($event) {
                            return _vm.onConditionFieldChange(cond)
                          }
                        },
                        model: {
                          value: cond.fieldName,
                          callback: function($$v) {
                            _vm.$set(cond, "fieldName", $$v)
                          },
                          expression: "cond.fieldName"
                        }
                      },
                      _vm._l(_vm.conditionFieldOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    cond.fieldName && _vm.isMultiValueField(cond.fieldName)
                      ? [
                          _c(
                            "span",
                            {
                              staticClass: "cond-label",
                              staticStyle: { margin: "0 6px" }
                            },
                            [_vm._v("等于(可多选)")]
                          ),
                          cond.fieldName === "customJobType"
                            ? _c(
                                "el-select",
                                {
                                  staticStyle: { width: "260px" },
                                  attrs: {
                                    multiple: "",
                                    filterable: "",
                                    "allow-create": "",
                                    placeholder: "选择业务类型"
                                  },
                                  model: {
                                    value: cond.fieldValueArr,
                                    callback: function($$v) {
                                      _vm.$set(cond, "fieldValueArr", $$v)
                                    },
                                    expression: "cond.fieldValueArr"
                                  }
                                },
                                _vm._l(_vm.customJobTypeOptions, function(c) {
                                  return _c("el-option", {
                                    key: c,
                                    attrs: { label: c + "类", value: c }
                                  })
                                }),
                                1
                              )
                            : cond.fieldName === "customerType"
                            ? _c(
                                "el-select",
                                {
                                  staticStyle: { width: "260px" },
                                  attrs: {
                                    multiple: "",
                                    placeholder: "选择客户类型"
                                  },
                                  model: {
                                    value: cond.fieldValueArr,
                                    callback: function($$v) {
                                      _vm.$set(cond, "fieldValueArr", $$v)
                                    },
                                    expression: "cond.fieldValueArr"
                                  }
                                },
                                _vm._l(_vm.customerTypeOptions, function(r) {
                                  return _c("el-option", {
                                    key: r.value,
                                    attrs: { label: r.label, value: r.value }
                                  })
                                }),
                                1
                              )
                            : _c(
                                "el-select",
                                {
                                  staticStyle: { width: "260px" },
                                  attrs: {
                                    multiple: "",
                                    filterable: "",
                                    "allow-create": "",
                                    placeholder: "选择业务类型"
                                  },
                                  model: {
                                    value: cond.fieldValueArr,
                                    callback: function($$v) {
                                      _vm.$set(cond, "fieldValueArr", $$v)
                                    },
                                    expression: "cond.fieldValueArr"
                                  }
                                },
                                _vm._l(_vm.lobOptions, function(l) {
                                  return _c("el-option", {
                                    key: l.value,
                                    attrs: { label: l.label, value: l.value }
                                  })
                                }),
                                1
                              )
                        ]
                      : _vm.isNumericConditionField(cond.fieldName)
                      ? [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "80px", margin: "0 6px" },
                              model: {
                                value: cond.operator,
                                callback: function($$v) {
                                  _vm.$set(cond, "operator", $$v)
                                },
                                expression: "cond.operator"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: ">=", value: ">=" }
                              }),
                              _c("el-option", {
                                attrs: { label: "<=", value: "<=" }
                              }),
                              _c("el-option", {
                                attrs: { label: "=", value: "=" }
                              }),
                              _c("el-option", {
                                attrs: { label: ">", value: ">" }
                              }),
                              _c("el-option", {
                                attrs: { label: "<", value: "<" }
                              })
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "120px" },
                            attrs: { placeholder: "数值" },
                            model: {
                              value: cond.fieldValue,
                              callback: function($$v) {
                                _vm.$set(cond, "fieldValue", $$v)
                              },
                              expression: "cond.fieldValue"
                            }
                          })
                        ]
                      : _c(
                          "span",
                          {
                            staticClass: "cond-label",
                            staticStyle: { margin: "0 6px", color: "#C0C4CC" }
                          },
                          [_vm._v("← 请选择字段")]
                        ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.form.conditions.splice(idx, 1)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  2
                )
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "text", icon: "el-icon-plus" },
                  on: { click: _vm.addCondition }
                },
                [_vm._v("添加条件")]
              )
            ],
            2
          ),
          _c(
            "el-form-item",
            { attrs: { label: "生效日期" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "160px" },
                attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                model: {
                  value: _vm.form.effectiveDate,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "effectiveDate", $$v)
                  },
                  expression: "form.effectiveDate"
                }
              }),
              _c("span", { staticStyle: { margin: "0 8px" } }, [_vm._v("至")]),
              _c("el-date-picker", {
                staticStyle: { width: "160px" },
                attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                model: {
                  value: _vm.form.expireDate,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "expireDate", $$v)
                  },
                  expression: "form.expireDate"
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }